// extracted by mini-css-extract-plugin
module.exports = {"checkBox":"CheckgroupWidget_checkBox__3_uxF"};